import { CalendarPicker } from 'antd-mobile';
import { RightOutline } from 'antd-mobile-icons';
import dayjs from 'dayjs';
import styles from './index.module.scss';
import { useEffect, useState } from 'react';
import { getCurrentCycleStart, getWeekRange } from '@/pages/EnergyUsePlan/util';
import { isNil } from 'lodash-es';

interface DateRangeProps {
  limitTime?: boolean;
  dateRange?: [dayjs.Dayjs, dayjs.Dayjs | null];
  setDateRange: (dateRange: [dayjs.Dayjs, dayjs.Dayjs | null]) => void;
}

const DateRange = ({ limitTime, setDateRange, dateRange = [dayjs(), dayjs()] }: DateRangeProps) => {
  const [visible, setVisible] = useState(false);
  const [date, setDate] = useState<[dayjs.Dayjs, dayjs.Dayjs | null]>();

  useEffect(() => {
    setDate(dateRange);
  }, [dateRange]);

  const disableDate = getCurrentCycleStart();

  return (
    <div className={styles.dateRange}>
      <div style={{ fontSize: 15, color: '#666666' }}>申请时间范围</div>
      <div className={styles.dateText} onClick={() => setVisible(true)}>
        {dayjs(dateRange[0]).format('YYYY-MM-DD')} ～ {dayjs(dateRange[1]).format('YYYY-MM-DD')}
        <RightOutline />
      </div>

      <CalendarPicker
        visible={visible}
        value={date as unknown as [Date, Date]}
        min={isNil(limitTime) || limitTime ? disableDate.toDate() : undefined}
        selectionMode="range"
        onClose={() => setVisible(false)}
        onMaskClick={() => setVisible(false)}
        onConfirm={() => setDateRange(date!)}
        onChange={val => {
          const [start, end] = getWeekRange(dayjs(val![0]));
          setDate([start, end]);
        }}
      />
    </div>
  );
};

export default DateRange;
